<template>
  <div>
    <div class="inst-title">최소 두께 검사</div>
    <img class="mt-5 w-full" src="../../../assets/images/inst3.jpeg" />
    <pre class="inst-desc">
부품의 얇은 벽두께는 생산 공정에서 불량이 될 수 있습니다. (최소두께: 1mm)
또한 두께가 충분히 두껍더라도 한쪽에 무게가 많이 쏠리는 구조는 불안정하여 파단이 일어날 수 있습니다.</pre
    >

    <img class="mt-5 w-full" src="../../../assets/images/inst2.jpeg" />
    <pre class="inst-desc">
위 이미지와 같은 구조의 경우 모델을 분할하여 조립형으로 설계하시는 것이 가장 좋습니다.
모델 자체에 부분적으로 무게 균형이 있도록 설계해야 하고, 한쪽에 무게가 집중되는 구조라면 해당 부분에 쉘을 주어 경량화하는 방안을 고려해야 합니다. </pre
    >

    <div class="inst-subtitle">[생산공정 별 문제]</div>
    <pre
      class="inst-desc"
    >· 절삭가공 : 가공단계에서 파단<br>· 사출 : 사출 플라스틱이 끝까지 들어가지 않아 미성형<br>· 3D 프린팅 적층 가공 : 해당 부분이 누락되거나 변형</pre>
  </div>
</template>

<script setup></script>
